var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "enter": function enter($event) {
        return _vm.$emit('enter');
      },
      "after-enter": function afterEnter($event) {
        return _vm.$emit('after-enter');
      },
      "before-leave": function beforeLeave($event) {
        return _vm.$emit('before-leave');
      },
      "after-leave": function afterLeave($event) {
        return _vm.$emit('after-leave');
      }
    }
  }, [_vm.visible ? _c('div', {
    ref: "container",
    class: _vm.$style.ModalWrapper
  }, [_vm.$slots['close-btn'] ? _c('div', {
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._t("close-btn")], 2) : _vm.businessPage ? _c('div', {
    class: [_vm.$style.close, _vm.$style.closeBtn],
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('SIcon', {
    class: _vm.$style.arrowIcon,
    attrs: {
      "size": 20,
      "icon": "close"
    }
  })], 1) : _c('div', {
    class: [_vm.$style.closeBtn, _vm.closeButtonClasses]
  }, [_c('SButton', {
    attrs: {
      "theme": _vm.closeColor,
      "size": _vm.closeSize,
      "shadow": "",
      "equal": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('SIcon', {
    class: _vm.$style.closeIcon,
    attrs: {
      "icon": "close",
      "size": "24"
    }
  })], 1)], 1), _vm._v(" "), _vm._t("default")], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };